import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdvancedExerciseState } from 'src/app/advancedlesson/advancedlesson-player/advancedlesson-player.component';
import { AuthService } from 'src/app/auth/auth.service';
import { Lesson } from 'src/app/core/models/lesson';

export interface AdvancedlessonDialogData {
  lesson: Lesson,
  state: AdvancedExerciseState,
  timeLimit: number,
}

@Component({
  selector: 'app-advancedlesson-results-dialog',
  templateUrl: './advancedlesson-results-dialog.component.html',
  styleUrls: ['./advancedlesson-results-dialog.component.scss']
})
export class AdvancedlessonResultsDialogComponent implements OnInit {

  video: string;
  shouldPass: boolean;

  lessonObjectives = new Map<number, number>();

  language: string;

  constructor(
    private authService: AuthService,
    public dialogRef: MatDialogRef<AdvancedlessonResultsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AdvancedlessonDialogData) { }

  ngOnInit(){
    const {language_in_use} = this.authService.user$.value;
    this.language = language_in_use;
    
    //setup lessons objectives
    switch (language_in_use) {
      case 'uk':
        this.lessonObjectives
          .set(1, 20)
          .set(2, 20)
          .set(3, 20)
          .set(4, 20)
          .set(5, 20)
          .set(6, 20)
          .set(7, 25)
          .set(8, 25)
          .set(9, 25)
          .set(10, 30)
          .set(11, 30)
          .set(12, 30)

          // video decision
          this.setupVideoUK();
        break;

      case 'dk':
        this.lessonObjectives
          .set(1, 100)
          .set(2, 100)
          .set(3, 100)
          .set(4, 100)
          .set(5, 100)
          .set(6, 100)
          .set(7, 125)
          .set(8, 125)
          .set(9, 125)
          .set(10, 150)
          .set(11, 150)
          .set(12, 150)
    
        // video decision
        this.setupVideoDK();

        break;
      case 'de':
        this.lessonObjectives
          .set(1, 20)
          .set(2, 20)
          .set(3, 20)
          .set(4, 20)
          .set(5, 20)
          .set(6, 20)
          .set(7, 25)
          .set(8, 25)
          .set(9, 25)
          .set(10, 30)
          .set(11, 30)
          .set(12, 30)

          // video decision
          this.setupVideoDE();
      break;
    
      default:
        break;
    }

    
  }

  setupVideoDK() {    
    const {language_in_use} = this.authService.user$.value;
    // 100 apm ? 
    // accuracy ao contrario (3%)
    const lessonObjective = this.lessonObjectives.get(+this.data.lesson.id);
    const videosUnlock = new Map<number, string>()
      .set(1, 'P1')
      .set(2, 'P1')
      .set(3, 'P1')
      .set(4, 'P2')
      .set(5, 'P2')
      .set(6, 'P3')
      .set(7, 'P3')
      .set(8, 'P3')
      .set(9, 'P4')
      .set(10, 'P4')
      .set(11, 'P4')
      .set(12, 'P4')
    
    if(this.errorPercentage > 3) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/FA1.mp4`;
      this.shouldPass = false;      
      console.log('Rule #1, errorPercentage: ', this.accuracy);
      return;
    }

    if(this.apm < lessonObjective) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/FS3.mp4`;
      this.shouldPass = false;      
      console.log('Rule #2, wpm: ', this.wpm);
      return;
    }

    // we cant continue to next one
    const timeUsed = this.data.timeLimit - this.data.state.timeLeft;
    if(this.data.timeLimit !== timeUsed) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/FS3.mp4`;
      this.shouldPass = false;      
      console.log('Rule #3, not time used');
      return;
    }

    this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/${videosUnlock.get(+this.data.lesson.id)}.mp4`;
    this.shouldPass = true;
    console.log('Rule #3');
  }

  setupVideoUK() {    
    const {language_in_use} = this.authService.user$.value;
    // 100 apm ? 
    // accuracy ao contrario (3%)
    const lessonObjective = this.lessonObjectives.get(+this.data.lesson.id);
        
    if(this.accuracy < 95) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/FA1.mp4`;
      this.shouldPass = false;      
      console.log('Rule #1, accuracy: ', this.accuracy);
      return;
    }

    if(this.wpm < lessonObjective) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/FS3.mp4`;
      this.shouldPass = false;      
      console.log('Rule #2, wpm: ', this.wpm);
      return;
    }

    // we cant continue to next one
    const timeUsed = this.data.timeLimit - this.data.state.timeLeft;
    if(this.data.timeLimit !== timeUsed) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/FS3.mp4`;
      this.shouldPass = false;      
      console.log('Rule #3, not time used');
      return;
    }

    this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/P4.mp4`;
    this.shouldPass = true;
    console.log('Rule #3');
  }

  setupVideoDE() {    
    const {language_in_use} = this.authService.user$.value;
    // 100 apm ? 
    // accuracy ao contrario (3%)
    const lessonObjective = this.lessonObjectives.get(+this.data.lesson.id);
        
    if(this.accuracy < 95) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/FA1.mp4`;
      this.shouldPass = false;      
      console.log('Rule #1, accuracy: ', this.accuracy);
      return;
    }

    if(this.wpm < lessonObjective) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/FS3.mp4`;
      this.shouldPass = false;      
      console.log('Rule #2, wpm: ', this.wpm);
      return;
    }

    // we cant continue to next one
    const timeUsed = this.data.timeLimit - this.data.state.timeLeft;
    if(this.data.timeLimit !== timeUsed) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/FS3.mp4`;
      this.shouldPass = false;      
      console.log('Rule #3, not time used');
      return;
    }

    this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/P4.mp4`;
    this.shouldPass = true;
    console.log('Rule #3');
  }

  get timeElapsed(): string {
    const timeUsed = this.data.timeLimit - this.data.state.timeLeft;
    const timeFormatted = new Date(timeUsed * 1000).toISOString().substr(11, 8);

    return timeFormatted;
  }

  get wpm(): number {    

    return isNaN(this.data.state.wpm ) 
      ? 0
      : +this.data.state.wpm .toFixed(2);
  }  

  get accuracy(): number {

    return isNaN(this.data.state.accuracy)
      ? 0
      : +this.data.state.accuracy.toFixed(2);
  }

  get apm(): number {
    const wpm = this.wpm;
    
    return wpm * 5;
  }

  get errorPercentage(): number {
    const accuracy = this.accuracy;
    return 100 - accuracy;
  }

}
